import SortUtils from "@utils/sort.utils";

/**
 * This mixin will populate school options and default selected school for school dropdown.
 * 'schools' field must be present in the component in order to for this mixin to work
 */
export default {
  computed: {
    sortedSchools() {
      return this.schools;
    },
    schoolOptions() {
      return this.sortedSchools.map((school) => ({
        name: school.schoolName,
        label: school.schoolName,
        value: school.id.toString(),
      }));
    },
    manageableSchoolOptions() {
      let manageableSchools = this.sortedSchools.filter(
        (schoolOption) => schoolOption.manageable === true,
      );
      return manageableSchools.map((school) => ({
        name: school.schoolName,
        label: school.schoolName,
        value: school.id.toString(),
      }));
    },
    schoolCodeOptions() {
      let optionList = this.sortedSchools.map((school) => ({
        name: school.schoolName,
        label: school.schoolName,
        value: school.schoolCode,
      }));
      return optionList;
    },
    defaultSelectedSchool() {
      return this.sortedSchools[0].id.toString();
    },
    defaultSelectedSchoolCode() {
      return this.sortedSchools[0].schoolCode.toString();
    },
  },
  methods: {
    sortSchools(schools) {
      const sortConfig = [{ field: "schoolName", asc: true }];
      return SortUtils.sortObjects(schools, sortConfig);
    },
  },
};
